__turbopack_context__.v({
  "actionBtn": "TopLeads-module__i_wQ6q__actionBtn",
  "actionBtnDisabled": "TopLeads-module__i_wQ6q__actionBtnDisabled",
  "actions": "TopLeads-module__i_wQ6q__actions",
  "avatar": "TopLeads-module__i_wQ6q__avatar",
  "card": "TopLeads-module__i_wQ6q__card",
  "cardBody": "TopLeads-module__i_wQ6q__cardBody",
  "cardHeader": "TopLeads-module__i_wQ6q__cardHeader",
  "company": "TopLeads-module__i_wQ6q__company",
  "date": "TopLeads-module__i_wQ6q__date",
  "emptyState": "TopLeads-module__i_wQ6q__emptyState",
  "floatLink": "TopLeads-module__i_wQ6q__floatLink",
  "floatMeta": "TopLeads-module__i_wQ6q__floatMeta",
  "footer": "TopLeads-module__i_wQ6q__footer",
  "name": "TopLeads-module__i_wQ6q__name",
  "scroll": "TopLeads-module__i_wQ6q__scroll",
  "stats": "TopLeads-module__i_wQ6q__stats",
});
